import { render } from "./Breadcrumb.vue?vue&type=template&id=5becf12f&scoped=true&lang=pug"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"

import "./Breadcrumb.vue?vue&type=style&index=0&id=5becf12f&lang=scss&scoped=true"

import exportComponent from "C:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5becf12f"]])

export default __exports__